<template>
  <div class="topbar">
    <KeywordFilter :lookup="'permits/fetch'" :limit="permitsLimit"/>
    <div class="topbar__cell">
      <counters>
        <template slot="total">{{permits.total}}</template>
      </counters>
      <!--<div class="buttonset">
        <router-link class="btn btn--main" :to="{ name: 'add-permit' }">{{ $t('top_bar.add_new_permit') }}</router-link>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Autocomplete from 'common/Autocomplete';
import Counters from 'common/Counters';
import Messages from 'common/Messages';
import KeywordFilter from 'common/KeywordFilter';

export default {
  components: {
    Autocomplete,
    Counters,
    Messages,
    KeywordFilter,
  },
  data() {
    return {
    };
  },
  computed: mapGetters({
    permits: 'landlord/permits/permits',
    permitsLimit: 'landlord/permits/limit',
  }),
};
</script>

<style lang="scss" scoped>
.messages {
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/permits/Topbar.vue